import { getCookie, setCookie, eraseCookie } from './storage.js';

export const getUserInfo = () => {
    // Try cookie first for cross-subdomain support
    const info = getCookie('userInfo') || localStorage.getItem('userInfo');
    try {
        return info ? JSON.parse(info) : null;
    } catch (e) {
        console.error("Error parsing user info", e);
        return null;
    }
};

export const setUserInfo = (info) => {
    const infoStr = JSON.stringify(info);
    localStorage.setItem('userInfo', infoStr);
    setCookie('userInfo', infoStr, 30);
};

export const clearUserInfo = () => {
    localStorage.removeItem('userInfo');
    eraseCookie('userInfo');
};

export const isLogin = () => {
    return !!getUserInfo();
};

export const userEmail = () => {
    const info = getUserInfo();
    return info ? info.email : '';
};

export const isVip = () => {
    const info = getUserInfo();
    return info ? !!info.vip : false;
};

export const canUseFeature = () => {
    const info = getUserInfo();
    if (info) {
        if (info.vip) return true;
        if (info.fileBalance && info.fileBalance > 0) return true;
    }
    return false;
};

export const handleReset = () => {
    window.location.reload();
};

